var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}; // If a `redirectTo` has been specified on this route config, then the `willActivate`
// callback will redirect throw with a redirect.


import UrlPattern from 'url-pattern';
import Navigation from '../model/Navigation';
import transformConfig from './transformConfig';

function NOP(a, b) {
  return Promise.resolve();
}

export default transformConfig(function (config) {
  if (typeof config.redirectTo === 'string') {
    var _willActivate = typeof config.willActivate === 'function' ? config.willActivate : NOP;

    var pattern = new UrlPattern(config.redirectTo);

    var willActivate = function willActivate(route, navigation) {
      var url = pattern.stringify(route.params);

      _willActivate(route, navigation);

      return navigation.redirectTo(url);
    };

    return _extends({}, config, {
      willActivate: willActivate
    });
  } else {
    return config;
  }
});